import { useState } from "react";
import { topicTags } from "@/mocks/home";

export default function TopicWall() {
  const [active, setActive] = useState<string | null>(null);

  const activeTag = topicTags.find((tag) => tag.id === active);
  const isLarge = (count: number) => count >= 130;
  const isMedium = (count: number) => count >= 80 && count < 130;

  return (
    <section id="topics" className="w-full bg-background-50 py-12 md:py-16">
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-8">
            <div>
              <span className="inline-flex items-center gap-1.5 text-secondary-600 text-sm font-medium">
                <i className="ri-price-tag-3-line text-base leading-none"></i>
                话题墙
              </span>
              <h2 className="mt-2 font-heading font-bold text-foreground-950 text-2xl md:text-3xl">
                按标签找你想查的那类小破绽
              </h2>
            </div>
            <p className="text-foreground-600 text-sm max-w-md">
              标签按收录条目数量排布，越靠前的写法在高频争议里出现得越多，点一下即可聚焦。
            </p>
          </div>

          <div className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-8">
            <div className="flex flex-wrap gap-2.5 md:gap-3">
              {topicTags.map((tag) => {
                const selected = active === tag.id;
                const size = isLarge(tag.count)
                  ? "text-base md:text-lg"
                  : isMedium(tag.count)
                    ? "text-sm md:text-base"
                    : "text-xs md:text-sm";
                return (
                  <button
                    key={tag.id}
                    type="button"
                    onClick={() => setActive(selected ? null : tag.id)}
                    className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full border whitespace-nowrap cursor-pointer transition-colors ${size} ${
                      selected
                        ? "bg-primary-500 border-primary-500 text-background-50"
                        : "bg-background-50 border-background-200 text-foreground-800 hover:border-secondary-300 hover:bg-secondary-50"
                    }`}
                  >
                    <span className="font-medium">#{tag.label}</span>
                    <span className={selected ? "text-background-200" : "text-foreground-500"}>
                      {tag.count}
                    </span>
                  </button>
                );
              })}
            </div>

            <div className="mt-6 pt-5 border-t border-background-200 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
              <p className="text-foreground-600 text-sm">
                {activeTag ? (
                  <>
                    已聚焦
                    <span className="mx-1 font-medium text-primary-600">#{activeTag.label}</span>
                    ，共
                    <span className="mx-1 font-medium text-foreground-950">{activeTag.count}</span>
                    条相关条目，按时间码顺序排列。
                  </>
                ) : (
                  "共 16 个高频标签，选中任意一个可以只看该话题下的分析条目。"
                )}
              </p>
              <div className="flex items-center gap-2">
                {activeTag && (
                  <button
                    type="button"
                    onClick={() => setActive(null)}
                    className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-md border border-background-300 text-foreground-700 text-sm whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors"
                  >
                    <i className="ri-close-line text-base leading-none"></i>
                    清除
                  </button>
                )}
                <a
                  href="#feed"
                  className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-secondary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-secondary-600 transition-colors"
                >
                  查看条目
                  <i className="ri-arrow-right-s-line text-base leading-none"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}